<template>
	<div class="tab-body">
		<div class="search">
			<el-form ref="form" :model="searchParams" label-width="80px">
				<el-row>
					<el-col :span="6">
						<el-form-item label="姓名">
							<el-input v-model="searchParams.name"></el-input>
						</el-form-item>
					</el-col>



					<el-col :span="6">
						<el-form-item label="班级">
							<el-select v-model="selectedClassId" placeholder="请选择班级" @change="handleClassChange">
								<el-option v-for="clazz in clazzList" :key="clazz.id" :label="clazz.name"
									:value="clazz.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>

					<el-col :span="8">
						<el-form-item label="学生">
							<div v-if="stuList && stuList.length > 0"
								style="display: flex;margin-top:4px; margin-left:10px">
								<el-button type="success" :disabled="stuIdx == 0" size="mini"
									@click="naviStu(-1)">《《</el-button>
								<el-select @change="handleStuSelect" v-model="selectedStuName" placeholder="请选择"
									style="margin: 0 5px;">
									<el-option v-for="student in stuList" :key="student.name" :label="student.name"
										:value="student.name">
									</el-option>
								</el-select>
								<el-button type="success" :disabled="stuIdx == (stuList.length - 1)" size="mini"
									@click="naviStu(1)">》》</el-button>
							</div>
							<el-input v-else placeholder="学生" v-model="searchParams.stuName">
							</el-input>
						</el-form-item>
					</el-col>


					<div class="search-btn">
						<el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
						<el-button @click="clearSearchVal">清空</el-button>

					</div>
				</el-row>
			</el-form>
		</div>
		<div class="operator">
			<el-button type="primary" size="mini" icon="el-icon-plus" @click="toSave()">添加</el-button>
			<el-button type="danger" size="mini" icon="el-icon-delete" @click="batchRemove()">批量删除</el-button>
		</div>
		<div class="dataTable autoFlex" v-if="listData">
			<el-table class="table" :data="listData.records" stripe border height="auto"
				@selection-change="selectionChange" v-loading="listLoading">
				<el-table-column type="selection" width="55" fixed="left"></el-table-column>
				<!-- <el-table-column prop="kid" label="考试id"></el-table-column> -->
				<!-- <el-table-column prop="cid" label="班级id"></el-table-column> -->
				<!-- <el-table-column prop="sid" label="考试人id"></el-table-column> -->
				<el-table-column prop="score" label="得分"></el-table-column>
				<el-table-column prop="answer" label="考生的答案"></el-table-column>
				<!-- <el-table-column prop="expid" label="试卷id"></el-table-column> -->
				<el-table-column prop="isjudged" label="答卷是否已批"></el-table-column>
				<el-table-column prop="crtm" label="创建时间"></el-table-column>
				<el-table-column prop="crer" label="创建人"></el-table-column>
				<el-table-column prop="mdtm" label="修改时间"></el-table-column>
				<el-table-column prop="mder" label="修改人"></el-table-column>
				<el-table-column label="操作" fixed="right" width="200px">
					<template slot-scope="scope">
						<div class="dataTable-operator">
							<el-button v-has-permission-code-and="''" size="mini" icon="el-icon-search"
								@click="toDetail(scope.$index, scope.row)">详情</el-button>
							<el-button v-has-permission-code-and="''" size="mini" icon="el-icon-edit"
								@click="toUpdate(scope.$index, scope.row)">编辑</el-button>
							<el-button v-has-permission-code-and="''" size="mini" icon="el-icon-delete" type="danger"
								@click="remove(scope.$index, scope.row)">删除</el-button>

						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="pageBar">
				<el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
					:page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
					:page-sizes="this.$constant.page.pageSizes"></el-pagination>
			</div>
		</div>
		<edit ref="edit"></edit>
	</div>
</template>
<script>
import edit from './edit.vue';
import api from '@/api/exams/answers/answers.js';
import studentApi from '@/api/stus/student/student.js';
import clazzApi from '@/api/edu/clazz/clazz.js';  // 添加这一行
export default {
	name: 'answers',
	components: {
		edit
	},
	data() {
		return {
			searchParams: {},
			isShowMoreSearch: false,
			listLoading: false,
			listData: [],
			selected: [],
			page: new this.$constant.pageObj(),
			// 班级相关数据
			clazzList: [],         // 班级列表              
			selectedClassId: '',   // 选中的班级ID          
			// 学生相关数据
			stuList: [],           // 学生列表
			stuIdx: 0,             // 当前选中学生索引
			selectedStuName: '',   // 当前选中学生姓名

		};
	},
	methods: {
		//获取数据
		list() {
			this.listLoading = true;
			let params = this.$utils.merger(this.searchParams, this.page);
			api.list(params, response => {
				this.listData = response.data;
				console.log(response.data);
				console.log('aaaaaaaaaaaaaaaaaaaaaaaa');
				console.log(this.listData.records);
				this.listLoading = false;
			})
		},
		//去添加
		toSave() {
			this.$refs.edit.open({}, '添加');
		},
		//去编辑
		toUpdate(index, row) {
			let editParameter = {
				id: row.id
			};
			this.$refs.edit.open(editParameter, '编辑');
		},
		//去详情
		toDetail(index, row) {
			let detailParameter = {
				id: row.id
			};
			this.$refs.edit.open(detailParameter, '详情', true);
		},
		//删除
		remove(index, row) {
			let parameter = {
				ids: row.id
			}
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				api.remove(
					parameter,
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//批量删除
		batchRemove() {
			if (!this.selected || this.selected.length == 0) {
				this.$utils.msg.info('请选择至少一行');
				return;
			}
			let parameter = {
				ids: this.selected
			};
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				api.remove({
					ids: this.selected
				},
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//改变选择项
		selectionChange(val) {
			//清空
			this.selected = [];
			for (let item of val) {
				this.selected.push(item.id);
			}
		},
		//改变每页显示数量
		sizeChange(val) {
			this.page.size = val;
			this.list();
		},
		//改变现在的页码
		currentChange(val) {
			this.page.current = val;
			this.list();
		},

		//搜索
		search() {
			this.list();

		},
		//清空搜索框
		clearSearchVal() {
			this.searchParams = {};
			this.selectedClassId = '';
			this.stuList = [];
			this.stuIdx = 0;
			this.selectedStuName = '';
			this.$delete(this.searchParams, 'sid');
		},
 // 班级选择变化处理
    handleClassChange(val) {
      this.selectedClassId = val;
      // 清空之前的学生选择
      this.stuList = [];
      this.stuIdx = 0;
      this.selectedStuName = '';

      // 如果选择了班级，则加载该班级的学生
      if (val) {
        this.loadStudentsByClass(val);
      } else {
        // 如果取消了班级选择，清除班级筛选条件
        this.$delete(this.searchParams, 'cid');
        this.page.current = 1;
        this.list();
      }
    },

		// 加载所有班级
		loadClazzList() {
			clazzApi.list({}, response => {
				this.clazzList = response.data.records || [];
			});
		},

// 根据班级加载学生
    loadStudentsByClass(classId) {
      if (classId) {
        // 使用班级ID加载该班级的学生列表
        studentApi.stuInClass({ cid: classId }, response => {
          // stuInClass接口返回的是List<String>，即学生姓名列表
          this.stuList = response.data.map(name => ({ name: name }));
          // 设置班级ID为搜索条件
          this.$set(this.searchParams, 'cid', classId);
          // 清除学生相关搜索条件
          this.$delete(this.searchParams, 'sid');
          
          // 如果有学生，则默认选中第一个学生
          if (this.stuList && this.stuList.length > 0) {
            this.stuIdx = 0;
            this.selectedStuName = this.stuList[0].name;
            // 触发学生选择事件，加载该学生的数据
            this.handleStuSelect(this.selectedStuName);
          } else {
            // 如果没有学生，清空学生相关数据
            this.stuIdx = 0;
            this.selectedStuName = '';
            this.$delete(this.searchParams, 'stuName');
            // 重新加载数据（只按班级筛选）
            this.page.current = 1;
            this.list();
          }
        });
      }
    },
		// 加载所有学生（不按班级筛选）
		loadAllStudents() {
			// 只有在没有选择班级时才加载所有学生
			if (!this.selectedClassId) {
				studentApi.list({}, response => {
					this.stuList = response.data.records || [];
					// 清空之前选中的学生
					this.stuIdx = 0;
					this.selectedStuName = '';
					// 清空学生搜索条件
					this.$delete(this.searchParams, 'sid');
					// 重新加载数据
					this.page.current = 1;
					this.list();
				});
			}
		},
    // 学生选择处理
    handleStuSelect(val) {
      // 根据学生姓名进行筛选
      if (val) {
        this.$set(this.searchParams, 'stuName', val);
        // 保留班级筛选条件
        if (this.selectedClassId) {
          this.$set(this.searchParams, 'cid', this.selectedClassId);
        }
      } else {
        // 清除学生筛选条件
        this.$delete(this.searchParams, 'stuName');
        // 保留班级筛选条件
        if (this.selectedClassId) {
          this.$set(this.searchParams, 'cid', this.selectedClassId);
        } else {
          this.$delete(this.searchParams, 'cid');
        }
      }
      // 重新加载数据
      this.page.current = 1;
      this.list();
    },
    // 学生导航（前后切换学生）
    naviStu(step) {
      this.stuIdx += step;
      if (this.stuIdx >= 0 && this.stuIdx < this.stuList.length) {
        this.selectedStuName = this.stuList[this.stuIdx].name;
        this.handleStuSelect(this.selectedStuName);
      }
    },

	},
	mounted() {
		this.list();
		this.loadClazzList();

	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
</style>
